import React, {useCallback} from 'react';
import Button from 'devextreme-react/button';
import {TextBox} from 'devextreme-react';

const defaultWrapperStyle = {display: 'flex', alignItems: 'center'};
const defaultButtonStyle = {marginLeft: '10px'};

const useInputButton = () => {
  return useCallback(({
    value,
    onValueChanged,
    readOnly,
    disabled,
    textBoxProps,
    buttonProps,
    wrapperStyle,
    buttonStyle,
  }) => {
    return (
      <div style={wrapperStyle || defaultWrapperStyle}>
        <TextBox
          value={value}
          onValueChanged={onValueChanged}
          readOnly={readOnly}
          disabled={disabled}
          style={{flexGrow: 1}}
          {...(textBoxProps || {})}
        />
        <Button
          disabled={disabled}
          style={buttonStyle || defaultButtonStyle}
          {...(buttonProps || {})}
        />
      </div>
    );
  }, []);
};

export default useInputButton;

